import {Component, Input, OnDestroy} from '@angular/core';

@Component({
  selector: 'loading-spinner',
  styleUrls: ['spinner.css'],
  templateUrl: 'spinner.html'
})
export class SpinnerComponent  {  
  private currentTimeout: any;
  private isDelayedRunning: boolean = false;
  private showModal:boolean = false;
  
  @Input()
  public delay: number = 300;

  @Input()
  public set isRunning(value: boolean) {  
    this.isDelayedRunning = value;
    return;
  }

  @Input()
  public set showModalSpin(value:boolean){
    console.log('showModalSpin:', value);
    this.showModal = value;
  }

  checkDelayedRunning(){
    return this.isDelayedRunning;
  }

  checkShowModal(){
    return this.showModal;
  }

  private cancelTimeout(): void {
    this.isDelayedRunning = false;
  }

  ngOnDestroy(): any {
    this.cancelTimeout();
  }
}